import React from 'react';
import { ProductName } from 'anf-core-react';

export default function ExchangesQuickviewNameAndDescription({ activeProduct, exchangeColorAndSize }) {
  return (
    <div
      className="name-and-description-container"
      data-product-brand={activeProduct?.brand}
      data-testid="exchanges-name-and-description-container"
    >
      <h2 data-type-style="h2">
        {exchangeColorAndSize}
      </h2>
      <ProductName brand={activeProduct?.brand} size="l">
        <h1
          className="product-title-component product-title-main-header"
          data-testid="main-product-name"
        >
          {activeProduct?.productName}
        </h1>
      </ProductName>
    </div>
  );
}
